<div class="top-bar flex-row justify-start align-center">
  <!-- logo-->
  <app-logo class="top-bar-logo"
            matRipple
            (click)="onHomeClick()"></app-logo>

  <!-- Site & date-->
  <app-menu-context-selector class="top-bar-context-selector flex-none offset-10"
                             (placeEditEvent)="onPlaceEdit($event)"
                             [isLoading]="(isLoading$ | async)"
                             [orderingIsOpen]="(orderingIsOpen$ | async)"
                             [deliveryDate]="(deliveryDate$ | async)"
                             (deliveryDateChange)="onDeliveryDateChange($event)"
                             [displayDeliveryDatePicker]="(displayDeliveryDatePicker$ | async)"></app-menu-context-selector>

  <!-- filler (white space) -->
  <div class="top-bar-filler"> </div>
  <!-- Mon compte-->
  <button mat-button
          class="top-bar-account-button top-bar-account offset-10"
          (click)="onAccountClick()">
    <mat-icon svgIcon="account-circle-solid"></mat-icon>
    <span class="account-label"> {{ "ACCOUNT.TITLE" | transloco }}</span>
  </button>
  <!-- Panier-->
  <button mat-icon-button
          class="top-bar-cart-button flex-none"
          (click)="onPanelClick()">
    <mat-icon svgIcon="shopping-basket"
              color="primary"
              [matBadge]="(cartBadgeValue$ | async)"
              matBadgeSize="small"
              [matBadgeHidden]="(cartBadgeValue$ | async) < 1"></mat-icon>
  </button>
</div>
